import React from 'react'

const ControlSystem = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Automation Solution</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Process Solution</span>
                        <i class="fa fa-angle-right"></i>
                        <span>Control System</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/control_system.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>Control System:</h2>
                        <p className="mbot25">
                            Our advanced control systems manage and regulate the behavior of
                            your industrial devices and processes. We design systems that range
                            from simple feedback mechanisms to sophisticated computer-based
                            controls for diverse applications.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ControlSystem
